/**
 * Configuration des filtres dynamiques pour le Top 10A
 * 
 * Pour chaque section (countries, clients, products), on définit :
 * - filters: tableau des filtres qui affectent cette section
 * - filterMapping: comment mapper chaque filtre aux champs des données
 * 
 * Exemple: Si countries.filters = ['products', 'clients'], alors la section pays
 * sera filtrée en fonction des produits et clients sélectionnés
 */

const TOP10A_DYNAMIC_FILTERS_CONFIG = {
  // Configuration pour la section Top 10 Countries
  countries: {
    filters: ['products', 'clients'],
    filterMapping: {
      products: {
        field: 'product_name',
        exact: true
      },
      clients: {
        field: row => row.buyer_p3 || row.buyer_name || "Unknown Client",
        exact: true
      }
    }
  },

  // Configuration pour la section Top 10 Clients
  clients: {
    filters: ['products', 'countries'],
    filterMapping: {
      products: {
        field: 'product_name',
        exact: true
      },
      countries: {
        field: 'buyer_country',
        exact: true
      }
    }
  },

  // Configuration pour la section Top 10 Products
  products: {
    filters: ['countries', 'clients'],
    filterMapping: {
      countries: {
        field: 'buyer_country',
        exact: true
      },
      clients: {
        field: row => row.buyer_p3 || row.buyer_name || "Unknown Client",
        exact: true
      }
    }
  }
}

export default TOP10A_DYNAMIC_FILTERS_CONFIG 